import { Chip as MuiChip } from '@mui/material';
import { cn } from 'cn';

import { type UUID } from '~/types/common';

import { Icon } from '@vestigas/ui';

type P = {
  readonly clickable?: boolean;
  readonly deletable?: boolean;
  readonly id?: string;
  readonly isPaginationChip?: boolean;
  readonly name: JSX.Element | string;
  readonly onClick?: (item: UUID | undefined) => void;
  readonly onDelete?: (item: UUID | undefined) => void;
  readonly onPaginationClick?: () => void;
  readonly selected?: boolean;
} & ComponentStyling;

export const Chip = ({
  className,
  clickable,
  deletable,
  id,
  isPaginationChip,
  name,
  onClick,
  onDelete,
  onPaginationClick,
  selected,
  style,
}: P) => {
  const isClickable = Boolean(isPaginationChip) || clickable;
  const isDeletable = !isPaginationChip && deletable;

  const handleClick = () => {
    if (!isClickable) {
      return;
    }

    if (isPaginationChip) {
      onPaginationClick?.();
    } else {
      onClick?.(id);
    }
  };

  const handleDelete = () => {
    if (!isDeletable) {
      return;
    }

    onDelete?.(id);
  };

  return (
    <div
      className="relative"
      onClick={(event) => {
        event.stopPropagation();
        event.preventDefault();
      }}
      onMouseDown={handleClick}
    >
      <MuiChip
        key={id}
        className={cn(
          selected ? 'bg-primary500 text-white' : 'text-gray-800',
          {
            'cursor-pointer': isClickable,
          },
          className,
        )}
        icon={
          selected ? (
            <Icon className="text-white" metaphor="check" size="inherit" />
          ) : undefined
        }
        label={name}
        style={style}
        onDelete={isDeletable ? handleDelete : undefined}
      />
    </div>
  );
};
